import { t } from "i18next";
import React, { useContext, useEffect } from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";
import { BasicContext } from "../App";

const NoPermission = () => {
    const { setAlerts, logout } = useContext(BasicContext);
    useEffect(() => {
        setAlerts([]);
        const main = document.getElementById("main"),
            footerMain = document.getElementById("footerMain").offsetHeight;
        main.style.minHeight = `${window.innerHeight - footerMain}px`;
        // eslint-disable-next-line
    }, []);
    return (
        <main id="main">
            <Container>
                <Row>
                    <Col>
                        <p className="h3 my-5 text-center">{t("permissionDenied")}</p>
                        <p className="text-center">
                            <Image src="/images/permission_denied.webp" alt="gif from star trek saying: you're not exactly in a position to make requests" fluid />
                        </p>
                        <p className="text-center">{t("permissionDeniedTxt")}</p>
                        <div className="text-center">
                            <Button variant="primary" className="my-3" onClick={() => window.location.reload()}>
                                {t("refreshPage")}
                            </Button>
                            <br />
                            <Button
                                variant="outline-primary"
                                className="my-3"
                                onClick={() => {
                                    logout("no permission logout");
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 200);
                                }}
                            >
                                {t("logout")}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </main>
    );
};

export default NoPermission;
